import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";
import { OptimizationNestingSettings } from "shared";

export type UpdateOptimizationNestingParams = {
  optimizationId: string;
  newScrapMaterialBillingRate: number;
  syncQuoteRequestLines?: boolean;
};

export const updateOptimizationNesting = async ({
  optimizationId,
  newScrapMaterialBillingRate,
  syncQuoteRequestLines,
}: UpdateOptimizationNestingParams): Promise<OptimizationNestingSettings> => {
  const response = await api.optimizations.updateNesting.mutation({
    params: { id: optimizationId },
    body: { newScrapMaterialBillingRate, syncQuoteRequestLines },
  });

  if (response.status === 200) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to update optimization nesting", response.status, response.body);
};
